import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['eye', 'input'];

  static classes = ['eye', 'slashEye'];

  toggleMask() {
    if (this.eyeTarget.classList.contains(this.eyeClass)) {
      this.toPassword();
      this.toSlashEye();
    } else {
      this.toText();
      this.toEye();
    }
  }

  toPassword() {
    this.inputTarget.type = 'password';
  }

  toText() {
    this.inputTarget.type = 'text';
  }

  toSlashEye() {
    this.eyeTarget.classList.remove(this.eyeClass);
    this.eyeTarget.classList.add(this.slashEyeClass);
  }

  toEye() {
    this.eyeTarget.classList.remove(this.slashEyeClass);
    this.eyeTarget.classList.add(this.eyeClass);
  }
}
